export const commands = function() {
  return [
    {
      id: 1,
      isLabel: true,
      title: 'General',
      actions: [
        {
          id: 1,
          title: 'Create new Todo',
          desc: 'Navigate to dashboard to create a todo',
          icon: 'fas fa-clipboard-list',
          shortcut: shortcuts.get('Create new Todo'),
          exec: () => {
            const path = '/dashboard?new-todo=true'
            if (!this.$route.fullPath.endsWith(path)) this.navigate(path)
            else {
              this.modalShow = false
              document.querySelector('[data-btn="open-todo"]').click()
            }
          }
        },
        {
          ...createNav('Financial insights', 'fas fa-coins'),
          id: 2,
          exec: executePath.bind(this, '/financial/insights')
        },
        {
          ...createNav('Financial predictions', 'fas fa-coins'),
          id: 3,
          exec: executePath.bind(this, '/financial/predictions')
        }
      ]
    },
    {
      id: 2,
      isLabel: true,
      title: 'Reports',
      actions: [
        {
          ...createNav('Subscription Report', 'fas fa-scroll'),
          exec: executePath.bind(this, '/reports/subscriptions/new')
        },
        {
          ...createNav('Product Report', 'fas fa-scroll'),
          exec: executePath.bind(this, '/reports/products/new')
        },
        {
          ...createNav('Publisher Report', 'fas fa-scroll'),
          exec: executePath.bind(this, '/reports/publishers/new')
        },
        {
          ...createNav('Vendor Report', 'fas fa-scroll'),
          exec: executePath.bind(this, '/reports/vendors/new')
        },
        {
          ...createNav('License Report', 'fas fa-scroll'),
          exec: executePath.bind(this, '/reports/licenses/new')
        }
      ]
    },
    {
      id: 3,
      isLabel: true,
      title: 'System Settings',
      actions: [
        {
          ...createNav('Member Settings', 'fas fa-cogs'),
          exec: executePath.bind(this, '/member-settings')
        },
        {
          ...createNav('Users Settings', 'fas fa-user'),
          exec: executePath.bind(this, '/users-settings')
        },
        {
          ...createNav('Workflow settings', 'fas fa-cogs'),
          exec: executePath.bind(this, '/workflow-settings')
        },
        {
          ...createNav('Subscription workflow management', 'fas fa-cogs'),
          exec: executePath.bind(this, '/subscription-workflow-management')
        },
        ...(this.$store.getters.hasPermission('perform-data-imports')
          ? [
              {
                ...createNav('Data imports', 'fas fa-archive'),
                exec: executePath.bind(this, '/data-imports')
              }
            ]
          : []),
        {
          ...createNav('Imported subscriptions', 'fas fa-archive'),
          exec: executePath.bind(this, '/subscription-imports')
        },
        {
          ...createNav('Imported publisher/vendor', 'fas fa-archive'),
          exec: executePath.bind(this, '/provider-imports')
        },
        {
          ...createNav('Financial periods', 'fas fa-coins'),
          exec: executePath.bind(this, `/financial-periods?year=${new Date().getFullYear()}`)
        },
        {
          ...createNav('Product types', 'fas fa-file-powerpoint'),
          exec: executePath.bind(this, '/product-types')
        },
        {
          ...createNav('Subject categories', 'fas fa-file-powerpoint'),
          exec: executePath.bind(this, '/subject-categories')
        },
        {
          ...createNav('Departments', 'fas fa-address-book'),
          exec: executePath.bind(this, '/departments')
        },
        {
          ...createNav('Stakeholders', 'fas fa-address-book'),
          exec: executePath.bind(this, '/stakeholders')
        },
        {
          ...createNav('License term labels', 'fas fa-file-alt'),
          exec: executePath.bind(this, '/license-term-labels')
        },
        {
          ...createNav('License qualifier labels', 'fas fa-file-alt'),
          exec: executePath.bind(this, '/license-qualifier-labels')
        },
        {
          ...createNav('Todo Templates', 'fas fa-copy'),
          exec: executePath.bind(this, '/todo-templates')
        },
        {
          ...createNav('Metadata categories', 'fas fa-tags'),
          exec: executePath.bind(this, '/meta-data-categories')
        },
        {
          ...createNav('Metadata fields', 'fas fa-tags'),
          exec: executePath.bind(this, '/meta-data-fields')
        },
        {
          ...createNav('FTE', 'fas fa-tags'),
          exec: executePath.bind(this, '/fte')
        },
        {
          ...createNav('Forms', 'fas fa-globe'),
          exec: executePath.bind(this, '/forms')
        },
        {
          ...createNav('Recent actions', 'fas fa-globe'),
          exec: executePath.bind(this, '/recent-actions')
        }
      ]
    }
  ]
}

const shortcuts = new Map([
  ['Member Settings', 'mese'],
  ['Users Settings', 'usse'],
  ['Workflow settings', 'wose'],
  ['Subscription workflow management', 'swm'],
  ['Data imports', 'daim'],
  ['Imported subscriptions', 'imposu'],
  ['Imported publisher/vendor', 'impopv'],
  ['Financial year for subscriptions', 'fyrs'],
  ['Product types', 'prty'],
  ['Subject categories', 'suca'],
  ['Departments', 'dp'],
  ['Stakeholders', 'sk'],
  ['License term labels', 'ltl'],
  ['License qualifier labels', 'lql'],
  ['Todo Templates', 'tote'],
  ['Metadata categories', 'meca'],
  ['Metadata fields', 'mefi'],
  ['FTE', 'fte'],
  ['Forms', 'fr'],
  ['Recent actions', 'reac'],
  ['Create new Todo', 'crto'],
  ['Subscription Report', 'subre'],
  ['Product Report', 'prore'],
  ['Publisher Report', 'pubre'],
  ['Vendor Report', 'venre'],
  ['License Report', 'licre'],
  ['Financial insights', 'fiin'],
  ['Financial predictions', 'fipr'],
  ['Financial periods', 'fipe']
])

let id = 1

function createNav(title, icon) {
  return {
    id: id++,
    title: title,
    desc: `Navigate to ${title}`,
    icon,
    shortcut: shortcuts.get(title)
  }
}

function executePath(path) {
  if (!this.$route.fullPath.endsWith(path)) this.navigate(path)
  else this.modalShow = false
}
